import { render, staticRenderFns } from "./questionInfo.vue?vue&type=template&id=18f3e42d&scoped=true&"
import script from "./questionInfo.vue?vue&type=script&lang=js&"
export * from "./questionInfo.vue?vue&type=script&lang=js&"
import style0 from "./questionInfo.vue?vue&type=style&index=0&id=18f3e42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3e42d",
  null
  
)

export default component.exports